import axios from 'axios'
import { childAccountMappings } from '../../ts/components/fees/feeGroupMappings'
import { getBaseContracts } from './ewarrants'

function deserializeFees(response: any) {
  return response.data.data.map((fee) => {
    return _.assign({}, {
      id: fee.id
    }, fee.attributes)
  })
}

export function updateClientExecutionFees(
  accountId: string,
  marketplaceId: number,
  childAccountType: string,
  executionFees: ExecutionFee[]) {

  return axios.patch(`/md3api/executionFees/client?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}&childAccountType=${childAccountType}`, {
      data: filterPlaceholderFees(executionFees)
    })
}

export function updateAccountExecutionFees(
  accountId: string,
  marketplaceId: number,
  executionFees: ExecutionFee[]) {

  return axios.patch(`/md3api/executionFees/account?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}`, {
      data: filterPlaceholderFees(executionFees)
    })
}

export function getClientExecutionFees(
  accountId: string,
  marketplaceId: number,
  feeGroups: string[]
): Promise<ExecutionFee[]> {
  const url = `md3api/executionFees/client?accountId=${accountId}&marketplaceId=${marketplaceId}`

  const requests: Promise<ExecutionFee>[]  = feeGroups.map((group) => {
    return axios.get(url + `&childAccountType=${group}`).then(deserializeFees)
  })

  return Promise.all(requests)
}

export function getAccountExecutionFees(
  accountId: string,
  marketplaceId: number
): Promise<ExecutionFee[]> {
  const url = `md3api/executionFees/account?accountId=${accountId}&marketplaceId=${marketplaceId}`
  return axios.get(url).then(deserializeFees)
}

export function getEffectiveExecutionFees(
  accountId: string,
  marketplaceId: number
): Promise<ExecutionFee[]> {
  const url = `md3api/executionFees/effective?accountId=${accountId}&marketplaceId=${marketplaceId}`
  return axios.get(url).then(deserializeFees)
}

export function getEffectiveStorageFees(
  accountId: string,
  marketplaceId: number,
  metalId: number
): Promise<ExecutionFee[]> {
  const url = `md3api/storageFees/effective?accountId=${accountId}&marketplaceId=${marketplaceId}&metalId=${metalId}`
  return axios.get(url).then(deserializeFees)
}

export function getEffectiveEwarrantFees(
  accountId: string,
  marketplaceId: number,
  ewarrantFeeType: string
): Promise<EwarrantFee[]> {
  const url = `md3api/ewarrant${ewarrantFeeType}Fees/effective?accountId=${accountId}&marketplaceId=${marketplaceId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function updateClientStorageFees(accountId: string, marketplaceId: number, childAccountType: string, storageFees: StorageFee[]) {
  return axios.patch(`/md3api/storageFees/client?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}&childAccountType=${childAccountType}`, {
      data: filterPlaceholderFees(storageFees)
    })
}

export function updateClientEwarrantFees(accountId: string, marketplaceId: number, childAccountType: string, ewarrantFees: EwarrantFee[], ewarrantFeeType: string) {
  return axios.patch(`/md3api/ewarrant${ewarrantFeeType}Fees/client?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}&childAccountType=${childAccountType}`, {
      data: ewarrantFees
    })
}

export function updateAccountStorageFees(accountId: string, marketplaceId: number, storageFees: StorageFee[]) {
  return axios.patch(`/md3api/storageFees/account?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}`, {
      data: filterPlaceholderFees(storageFees)
    })
}

export function deleteAccountStorageFees(accountId: string, marketplaceId: number) {
  return axios.delete(`/md3api/storageFees/account/${accountId}`
    + `?marketplaceId=${marketplaceId}`)
}

export function deleteAccountExecutionFees(accountId: string, marketplaceId: number) {
  return axios.delete(`/md3api/executionFees/account/${accountId}`
    + `?marketplaceId=${marketplaceId}`)
}

export function getClientStorageFees(accountId: string, marketplaceId: number) {
  return axios.get(`/md3api/storageFees/client?accountId=${accountId}`
    + `&marketplaceId=${marketplaceId}&childAccountType='All'`).then(deserializeFees)
}

export function getClientEwarrantFees(
  accountId: string,
  marketplaceId: number,
  ewarrantFeeType: string,
  accountType: string): Promise<EwarrantFee[]> {
  const url = `md3api/ewarrant${ewarrantFeeType}Fees/client?accountId=${accountId}&marketplaceId=${marketplaceId}&childAccountType=${accountType}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getAccountStorageFees(
  accountId: string,
  marketplaceId: number,
  metalId: number
): Promise<StorageFee[]> {
  const url = `md3api/storageFees/account?accountId=${accountId}&metalId=${metalId}&marketplaceId=${marketplaceId}`
  return axios.get(url).then(deserializeFees)
}

function filterPlaceholderFees(fees: any[]) {
  return fees.filter((fee) => {
    return fee.tierValue > 0
  })
}

function paddingEwarrantFees(fees: EwarrantFee[], marketplaceId: number, accountType: string) {
  let newFees = [...fees]
  let contracts = getBaseContracts(marketplaceId)
  const contractMapped = _.map(contracts, (contract: any) => {
    const existingFee = _.find(newFees, { contractId: contract.id })
    if (!existingFee) {
      const newFee: any = {
        childAccountType: accountType,
        marketplaceId,
        tier: 1,
        tierValue: 0,
        metalId: 0,
        feeRate: 0.0,
        placeHolder: true,
        contractId: contract.id
      }
      return newFee
    }
  })
  return _.compact([...fees, ...contractMapped])
}

function paddingFeeRateTiers(
  feeRateTiers: any[],
  accountId: string,
  marketplaceId: number,
  feeTypeId: string,
  metalId?: number,
  clientType?: string,
  contractId?: number
) {
  let newFees = [...feeRateTiers]
  for (let i = feeRateTiers.length; i < 5; i++) {
    const newFee: any = {
      accountId: accountId,
      marketplaceId,
      feeTypeId: feeTypeId,
      tier: i + 1,
      tierValue: 0,
      feeRate: 0.0,
      placeHolder: true
    }
    if (feeTypeId === FeeType.storage) {
      newFee.metalId = metalId
      newFee.childAccountType = clientType
    }
    newFees = [...newFees, newFee]
  }
  return newFees
}

function handleEwarrantFees(fees: EwarrantFee[], marketplaceId: number, childAccountType: string) {
  const ewarrantFeeAssignment = _.map(fees, (fee) => {
    return Object.assign({}, fee, {
      childAccountType: childAccountType,
      marketplaceId: marketplaceId,
      metalId: 0
    })
  })

  return paddingEwarrantFees(ewarrantFeeAssignment, marketplaceId, childAccountType)
}

function handleStorageFees(
  storageFees: any[],
  accountId: string,
  marketplaceId: number
) {
  const storageFeesByTiers = _.groupBy(_.flatten(storageFees), 'metalId')
  return _.map(storageFeesByTiers, (storageFees, metalId) => {
    return paddingFeeRateTiers(storageFees, accountId, Number(marketplaceId), FeeType.storage, Number(metalId), 'All')
  })
}

function executionFeeClient(accountId: string, marketplaceId: number, activeClientType: string) {
  return getClientExecutionFees(
    accountId, marketplaceId,
    [childAccountMappings(activeClientType)]
  ).then((fees) => {
    const executionFees = _.map(fees, (executionFeeRateTiers: ExecutionFee[]) => {
      return paddingFeeRateTiers(executionFeeRateTiers, accountId, marketplaceId, FeeType.execution)
    })
    return {
      fees: executionFees
    }
  })
}

function executionFeeAccount(accountId: string, marketplaceId: number, activeClientType: string) {
  return getAccountExecutionFees(accountId, marketplaceId)
    .then((fees) => {
      return {
        isUsingDefaultFees: false,
        fees: [paddingFeeRateTiers(fees, accountId, marketplaceId, FeeType.execution)]
      }
    }, (e) => {
      return getEffectiveExecutionFees(accountId, marketplaceId)
        .then((fees) => {
          return {
            isUsingDefaultFees: true,
            fees: [paddingFeeRateTiers(fees, accountId, marketplaceId, FeeType.execution)]
          }
        })
    })
}

function storageFeeAccount(accountId: string, marketplaceId: number, activeClientType: string) {
  return Promise.all([
    getAccountStorageFees(accountId, marketplaceId, 1),
    getAccountStorageFees(accountId, marketplaceId, 2),
    getAccountStorageFees(accountId, marketplaceId, 3)
  ]).then((fees) => {
    const feeRateTiers = handleStorageFees(fees, accountId, Number(marketplaceId))
    return {
      isUsingDefaultFees: false,
      fees: [_.flatten(feeRateTiers)]
    }
  }, (e) => {
    return Promise.all([
      getEffectiveStorageFees(accountId, marketplaceId, 1),
      getEffectiveStorageFees(accountId, marketplaceId, 2),
      getEffectiveStorageFees(accountId, marketplaceId, 3)
    ]).then((fees) => {
      const feeRateTiers = handleStorageFees(fees, accountId, Number(marketplaceId))
      return {
        isUsingDefaultFees: true,
        fees: [_.flatten(feeRateTiers)]
      }
    })
  })
}

function storageFeeClient(accountId: string, marketplaceId: number, activeClientType: string) {
  return getClientStorageFees(accountId, marketplaceId)
    .then((fees) => {
      const feeRateTiers = handleStorageFees(fees, accountId, Number(marketplaceId))
      return {
        fees: [_.flatten(feeRateTiers)]
      }
    })
}

function ewarrantFeeAccount(accountId: string, marketplaceId: number, activeClientType: string, ewarrantFeeType: string) {
  return getEffectiveEwarrantFees(accountId, marketplaceId, ewarrantFeeType)
  .then((fees: any) => {
    return {
      isUsingDefaultFees: true,
      fees: [handleEwarrantFees(fees.attributes.json, Number(marketplaceId), 'All')]
    }
  })
}

function ewarrantFeeClient(accountId: string, marketplaceId: number, activeClientType: string, ewarrantFeeType: string) {
  return getClientEwarrantFees(accountId, marketplaceId, ewarrantFeeType, childAccountMappings(activeClientType))
    .then(async (fees: any) => {
      const handledFees = handleEwarrantFees(fees.attributes[0].json, Number(marketplaceId), childAccountMappings(activeClientType))
      const feesWithEffectiveDefaults = await setDefaultAsEffectiveEwarrant(handledFees, accountId, marketplaceId, ewarrantFeeType)
      return {
        fees: [feesWithEffectiveDefaults]
      }
    }).catch(async (e) => {
      const handledFees = paddingEwarrantFees([], Number(marketplaceId), childAccountMappings(activeClientType))
      const feesWithEffectiveDefaults = await setDefaultAsEffectiveEwarrant(handledFees, accountId, marketplaceId, ewarrantFeeType)
      return {
        fees: [feesWithEffectiveDefaults]
      }
    })
}

function setDefaultAsEffectiveEwarrant(handledFees: any, accountId: string, marketplaceId: number, ewarrantFeeType: string) {
  let defaultsToRetrieve = _.some(handledFees, (fee: any) => fee.placeHolder)
  if (!defaultsToRetrieve) {
    return handledFees
  }
  return getEffectiveEwarrantFees(accountId, marketplaceId, ewarrantFeeType).then((effectiveFees: any) => {
      let jsonFees = effectiveFees.attributes.json
      return _.map(handledFees, (fee: any) => {
        if (fee.placeHolder) {
          let sponsorDefault = _.find(jsonFees, (effectiveFee: any) => Number(effectiveFee.contractId) === Number(fee.contractId))
          if (sponsorDefault) {
            fee.feeRate = sponsorDefault.feeRate
          }
        }
        return fee
      })
  })
}

export function getFeesData(
  activeFeeType: string,
  feeView: string,
  accountId: string,
  marketplaceId: number,
  activeClientType: string,
  ewarrantFeeType?: string
) {
  if (activeFeeType === 'Execution Fees' && feeView === 'client') {
    return executionFeeClient(accountId, marketplaceId, activeClientType)
  } else if (activeFeeType === 'Execution Fees' && feeView === 'account') {
    return executionFeeAccount(accountId, marketplaceId, activeClientType)
  } else if (activeFeeType === 'Storage Fees' && feeView === 'account') {
    return storageFeeAccount(accountId, marketplaceId, activeClientType)
  } else if (activeFeeType === 'Storage Fees' && feeView === 'client') {
    return storageFeeClient(accountId, marketplaceId, activeClientType)
  } else if (activeFeeType === 'E-Warrant Fees' && feeView === 'account') {
    return ewarrantFeeAccount(accountId, marketplaceId, activeClientType, ewarrantFeeType)
  } else if (activeFeeType === 'E-Warrant Fees' && feeView === 'client') {
    return ewarrantFeeClient(accountId, marketplaceId, activeClientType, ewarrantFeeType)
  }
}



// WEBPACK FOOTER //
// ./react/api/fees.ts